<template>
  <div class="detail_content">
    <div class="total_period_label assessment_title_label">
      {{titleLabel}}
    </div>
    <datepickerSection :pickerId='startDate'
                       :titleLabel='startDateTitleLabel'></datepickerSection>
    <datepickerSection :pickerId='endDate'
                       :titleLabel='endDateTitleLabel'></datepickerSection>
  </div>
</template>

<script>
import datepickerSection from './datepickerSection.vue'

export default {
  props: {
    titleLabel: String
  },
  data () {
    return {
      startDateTitleLabel: '開始日',
      startDate: 'start_date',
      endDateTitleLabel: '終了日',
      endDate: 'end_date'
    }
  },
  computed: {
  },
  components: {
    datepickerSection
  },
  methods: {
    customFormatter (e) {
      let date = new Date(e)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      event.target.value = year + '/' + month + '/' + day
      this.$emit('inputUpdate', event.target.value)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/logExportCompornents/totalPeriodSection.vue